import { render, staticRenderFns } from "./Mailboxes.vue?vue&type=template&id=78955b3b&"
import script from "./Mailboxes.vue?vue&type=script&lang=js&"
export * from "./Mailboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports